import { useState, useEffect } from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import axios from 'axios';
import qs from 'qs';
import { Gantt } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";
import { rescueHtml } from '../Components/Tools';


const Page6GanttGlobal = (props) =>
{
    const blue = '#069BD3';
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;
    const greyChapter = '#DBDBDB';

    const [data, setData] = useState(undefined);

    async function getDatas(listeOperations)
    {
        let tmp = [];
        let key = 0;
        for (const element of listeOperations) {
            /* Filtre les opérations de l'hypothèse actuelle */
            if (element.h1 == 1 || element.h2 == 1 || element.h3 == 1) {
                try {
                    const result = await axios.post('https://app-slfinance.fr/api/gantt.php', qs.stringify({
                        'getStartEnd': true,
                        'id_operation': element.id
                    }));

                    if (result.data.start && result.data.end)
                    {
                        tmp.push({
                            id: key,
                            start: result.data.start?new Date(result.data.start):new Date(),
                            end: result.data.end?new Date(result.data.end):new Date(),
                            name: !result.data.start || !result.data.end ?rescueHtml(element.nom)+' (GANTT non renseigné)':rescueHtml(element.nom),
                            type: 'task',
                            styles: { 
                                backgroundColor: element.color && element.color !== '#ffffff'?element.color:'#bdc3c7', 
                                backgroundSelectedColor: element.color && element.color !== '#ffffff'?element.color:'#bdc3c7', 
                                progressColor: element.color && element.color !== '#ffffff'?element.color:'#bdc3c7', 
                                progressSelectedColor: element.color && element.color !== '#ffffff'?element.color:'#bdc3c7' 
                            },
                        });
                    }
                } catch (error) {
                    console.error('Erreur lors de la récupération des données:', error);
                }
            }
            key++;
        }
    
        setData(tmp);
    }

    useEffect(() => {
        if (props.operations) {
            getDatas(props.operations);
        }
    }, [props.operations])

    /* Custom Task List Header */
    function TaskListHeader({ headerHeight }) {
        return (
            <div style={{ display: 'flex', height: headerHeight, alignItems: 'center', backgroundColor: '#f5f5f9', borderBottom: '1px solid #ccc' }}>
                <p style={{ width: 100, paddingLeft: 10, fontSize: fontsize * 0.8, margin: 0 }}>N° d'inventaire</p>
                <p style={{ width: 180, paddingLeft: 10, fontSize: fontsize, margin: 0 }}>Opération</p>
                <p style={{ width: 25, textAlign: 'center', fontSize: fontsize, margin: 0 }}>H1</p>
                <p style={{ width: 25, textAlign: 'center', fontSize: fontsize, margin: 0 }}>H2</p>
                <p style={{ width: 25, textAlign: 'center', fontSize: fontsize, margin: 0 }}>H3</p>
            </div>
        );
    }

    /* Custom Task List Table */
    function TaskListTable({ rowHeight, fontFamily, fontSize, locale, tasks, selectedTaskId, setSelectedTask, onExpanderClick }) {
        return (
            <>
                {tasks && tasks.map((t, i) => {
                    // Trouver l'opération originale pour obtenir le numéro d'inventaire et les flags H1/H2/H3
                    const operation = props.operations && props.operations.find(op => op.nom === t.name.replace(' (GANTT non renseigné)', ''));
                    const numInventaire = operation?.numero_inventaire || '—';
                    const h1 = operation?.h1 == 1;
                    const h2 = operation?.h2 == 1;
                    const h3 = operation?.h3 == 1;
                    
                    return (
                        <div
                            key={`${t.id}~${i}`}
                            style={{
                                height: rowHeight,
                                display: 'flex',
                                alignItems: 'center',
                                borderBottom: '1px solid #e0e0e0',
                                backgroundColor: selectedTaskId === t.id ? '#f5f5f5' : 'white',
                                cursor: 'pointer'
                            }}
                            onClick={() => setSelectedTask(t.id)}
                        >
                            <p style={{ width: 100, paddingLeft: 10, fontSize: fontsize * 0.7, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {numInventaire}
                            </p>
                            <p style={{ width: 180, paddingLeft: 10, fontSize: fontsize * 0.8, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {t.name.replace(' (GANTT non renseigné)', '')}
                            </p>
                            <p style={{ width: 25, textAlign: 'center', margin: 0 }}>
                                <input
                                    type="checkbox"
                                    checked={h1}
                                    onChange={() => {}}
                                    style={{ transform: "scale(0.9)" }}
                                />
                            </p>
                            <p style={{ width: 25, textAlign: 'center', margin: 0 }}>
                                <input
                                    type="checkbox"
                                    checked={h2}
                                    onChange={() => {}}
                                    style={{ transform: "scale(0.9)" }}
                                />
                            </p>
                            <p style={{ width: 25, textAlign: 'center', margin: 0 }}>
                                <input
                                    type="checkbox"
                                    checked={h3}
                                    onChange={() => {}}
                                    style={{ transform: "scale(0.9)" }}
                                />
                            </p>
                        </div>
                    );
                })}
            </>
        );
    }

    const columnWidth = 250;

    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header */}
            <div style={{display: 'flex', height: '15%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: props.height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Calendrier de réalisation</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '80%', fontSize: fontsize, overflowY: 'hidden', overflowX: 'hidden', paddingLeft: '20px', paddingRight: '20px'}}>
                {/* Gantt Component */}
                {data && data.length > 0 ? (() => {
                    // Calcul du nombre d'années
                    const startDates = data.map(t => new Date(t.start).getFullYear());
                    const endDates = data.map(t => new Date(t.end).getFullYear());
                    const minYear = Math.min(...startDates);
                    const maxYear = Math.max(...endDates);
                    const numYears = maxYear - minYear + 1;
                    
                    // Calcul de la largeur disponible
                    const availableWidth = (props.width * 0.7) - 40 - 290; // width du PDF - marges - largeur tableau gauche (60+140+30+30+30=290)
                    const responsiveColumnWidth = Math.max(50, (availableWidth / numYears) * 0.80);
                    
                    return (
                        <Gantt
                            tasks={data}
                            viewMode="Year"
                            columnWidth={responsiveColumnWidth}
                            listCellWidth="auto"
                            locale="fr"
                            onDateChange={() => {}}
                            onTaskChange={() => {}}
                            onSelect={() => {}}
                            onExpanderClick={() => {}}
                            TaskListHeader={TaskListHeader}
                            TaskListTable={TaskListTable}
                            fontSize={fontsize}
                        />
                    );
                })() : (
                    <p style={{ fontSize: fontsize }}>Chargement des données du Gantt...</p>
                )}
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '5%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page6GanttGlobal;
